export const ONLINE_PAYMENT_LAST_PART_ROUTE = '[a-zA-Z0-9-.]+';

export const THANKS_FOR_YOUR_ORDER_LAST_PART_ROUTE = ONLINE_PAYMENT_LAST_PART_ROUTE;
